import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';
import moment from 'moment';

import { DatePicker } from 'material-ui-pickers';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import avatar from '@material-ui/core/colors/amber';

import InfoIcon from '@material-ui/icons/Info';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ScheduleIcon from '@material-ui/icons/Repeat';
import DeleteIcon from '@material-ui/icons/Delete';

import Header from './Header';
import { startEditBidTask, startRemoveBidTask } from '../../../../store/actions/bids';
import { startEditBidEditorState } from '../../../../store/actions/bidEditor';

const styles = theme => ({
  root: {
    margin: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
  scheduleAvatar: {
    marginRight: theme.spacing.unit*3,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  description: {
    flexGrow: 1,
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  amount: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  schedule: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
  },
  scheduleItems: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    alignItems: 'baseline',
  },
  scheduleItem: {
    marginRight: theme.spacing.unit*2,
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
  },
  actions: {
    margin: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

const JobTaskMaintenance = (props) => {
  const {
    classes,
    bidTask,
    bidValidation,
    showValidation,
    preview,
    startEditBidTask,
    startRemoveBidTask,
    startEditBidEditorState
  } = props;
  const startDate = moment(bidTask.scheduleStart, "MMMM Do YYYY");

  return(
      <Card className={classes.root}>
        <Header preview={preview} type="maintenance" bidTask={bidTask} focusType="jobTasksTitle"/>
        <div className={classes.flexRow}>
          <TextField
            disabled={preview}
            className={classes.description}
            id="description"
            label="Description"
            multiline
            rows="6"
            placeholder="Describe the task"
            margin="normal"
            value={bidTask.description}
            onFocus={() => startEditBidEditorState("jobTasksDescription")}
            onChange={(event) => {
              const value = event.target.value;
              startEditBidTask(bidTask.id, {description: value})
            }}
          />
          <div className={classes.amount}>
            <TextField
              error={(showValidation && !!bidValidation.validateField(`monthlyAmount-${bidTask.id}`))}
              helperText={(showValidation && bidValidation.validateField(`monthlyAmount-${bidTask.id}`))}
              disabled={preview}
              id="monthlyAmount"
              type="number"
              label="Monthly Amount"
              margin="normal"
              value={bidTask.monthlyAmount}
              onFocus={() => startEditBidEditorState("jobTasksMonthlyAmount")}
              onChange={(event) => {
                const value = event.target.value;
                startEditBidTask(bidTask.id, {monthlyAmount: value})
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          </div>
        </div>
        <div className={classes.schedule}>
          <Avatar className={classNames(classes.avatar, classes.scheduleAvatar)}>
            <ScheduleIcon />
          </Avatar>
          <div className={classes.scheduleItems}>
            <DatePicker
              disabled={preview}
              className={classes.scheduleItem}
              label="Starting Date"
              format="MMMM Do YYYY"
              value={bidTask.scheduleStart}
              leftArrowIcon={<ArrowBackIcon />}
              rightArrowIcon={<ArrowForwardIcon />}
              onFocus={() => startEditBidEditorState("jobTasksStartingDate")}
              onChange={(date) => startEditBidTask(bidTask.id, {scheduleStart: date.toDate().getTime()})}
            />
            <TextField
              disabled={preview}
              className={classes.scheduleItem}
              disabled
              id="scheduleFrequency"
              label="How often it occurs?"
              margin="normal"
              value="Monthly"
              onFocus={() => startEditBidEditorState("jobTasksFrequency")}
              onChange={(event) => {
                const value = event.target.value;
                startEditBidTask(bidTask.id, {scheduleFrequency: value})
              }}
            />
            <TextField
              error={(showValidation && !!bidValidation.validateField(`scheduleOccurences-${bidTask.id}`))}
              helperText={(showValidation && bidValidation.validateField(`scheduleOccurences-${bidTask.id}`))}
              disabled={preview}
              className={classes.scheduleItem}
              id="scheduleOccurences"
              label="How many times?"
              type="number"
              margin="normal"
              value={bidTask.scheduleOccurences}
              onFocus={() => startEditBidEditorState("jobTasksOccurences")}
              onChange={(event) => {
                const value = event.target.value;
                startEditBidTask(bidTask.id, {scheduleOccurences: value})
              }}
            />
            <TextField
              error={(showValidation && !!bidValidation.validateField(`scheduleHours-${bidTask.id}`))}
              helperText={(showValidation && bidValidation.validateField(`scheduleHours-${bidTask.id}`))}
              disabled={preview}
              className={classes.scheduleItem}
              id="scheduleHours"
              type="number"
              label="Hours Budget"
              margin="normal"
              value={bidTask.scheduleHours}
              onFocus={() => startEditBidEditorState("jobTasksBudget")}
              onChange={(event) => {
                const value = event.target.value;
                startEditBidTask(bidTask.id, {scheduleHours: value})
              }}
            />
          </div>
        </div>
        <div className={classes.footer}>
          <InfoIcon />
          <Typography>{`An invoice will be created every Month starting ${moment(bidTask.scheduleStart).format("MMMM Do YYYY")}`}</Typography>
        </div>
        {!preview &&
          <div className={classes.actions}>
            <Button
              aria-label="delete"
              size="small"
              className={classes.deleteButton}
              onClick={() => startRemoveBidTask(bidTask.id)}
              style={{color: 'grey'}}
              >
              <DeleteIcon />
            </Button>
          </div>
        }
      </Card>
  );
};

const mapStateToProps = (state, props) => {
  const { id: bidId, showValidation } = state.adminState.bid;
  const bidValidation = state.validation.bids.find(item => item.id === bidId);

  return ({
    bidValidation,
    showValidation,
  });
};

const mapDispatchToProps = {
  startEditBidTask,
  startEditBidEditorState,
  startRemoveBidTask,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(JobTaskMaintenance);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/JobTaskMaintenance.jsx